import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  useMediaQuery,
  Drawer,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import EmailSignupModal from "./EmailSignupModal";
import jeremiahLogo from "../images/jeremiahLogo.png";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "transparent!important",
    color: "#000",
    boxShadow: "none",
    position: "absolute!important",
    width: "100%",
  },
  menuButton: {
    color: "white!important",
    background: "transparent!important",
    fontFamily: "'Montserrat'",
    fontSize: "1rem",
    lineHeight: "1.25",
    padding: "0 .25rem",
    textTransform: "uppercase!important",
  },
  link: {
    textDecoration: "none",
    color: "#00853e",
    fontFamily: "'Montserrat'",
    fontSize: "14px",
    lineHeight: "1.25",
    padding: "0 .15rem",
  },
  toolbar: {
    justifyContent: "space-between",
  },
  drawerList: {
    width: 250,
  },
  menuIcon: {
    color: "white",
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const location = useLocation();

  const drawerList = () => (
    <div
      className={classes.drawerList}
      onClick={(e) => {
        if (e.target.tagName !== "A") toggleDrawer(false);
      }}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItemButton component={Link} to="/" onClick={toggleDrawer(false)}>
          <ListItemText primary="HOME" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to={{ pathname: "/", hash: "#meet-jeremiah" }}
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="MEET JEREMIAH" />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/priorities"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="PRIORITIES" />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to="/studentsforpope"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="STUDENTS FOR POPE" />
        </ListItemButton>
        {/* <ListItemButton
          component={Link}
          to="/media"
          onClick={toggleDrawer(false)}
        >
          <ListItemText primary="MEDIA" />
        </ListItemButton> */}
        {/* <ListItemButton
          component="a"
          href=""
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="CONTACT" />
        </ListItemButton> */}
        <ListItemButton
          component="a"
          href=""
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="VOLUNTEER" />
        </ListItemButton>
        {/* <ListItemButton
          component="a"
          onClick={() => setEmailOpen(true)}
        >
          <ListItemText primary="JOIN US" />
        </ListItemButton> */}

        {/* <ListItemButton
          component="a"
          href=""
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItemText primary="DONATE" />
        </ListItemButton> */}
      </List>
    </div>
  );

  return (
    <AppBar
      className={classes.appBar}
      sx={{
        background: "transparent!important",
        p: 1,
        pb: 0,
      }}
    >
      <Toolbar className={classes.toolbar} sx={{ px: "0!important" }}>
        <Box display={{ xs: "none", md: "flex", width: "100%" }}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            sx={{
              py: 1,
              px: 1,
              width: "100%",
              borderRadius: ".5rem",
            }}
          >
            {/* Logo */}
            <Grid
              item
              flexDirection="column"
              sx={{
                padding: "4px 8px 0 8px",
                borderRadius: "8px",
              }}
            >
              <Grid
                item
                display="flex"
                justifyContent="center"
                sx={{ position: "absolute" }}
              >
                <Link to="/">
                  <Box
                    component="img"
                    src={jeremiahLogo}
                    alt="Jeremiah Logo"
                    sx={{
                      borderRadius: ".5rem",
                      width: "250px",
                      height: "auto",
                    }}
                  />
                </Link>
              </Grid>
            </Grid>

            <Grid
              item
              sx={{
                background: "#ffffffb5",
                borderRadius: "4px",
                border: "1px solid",
              }}
            >
              {/* <Button className={classes.menuButton}>
                <Link to="/" className={`${classes.link}`}>
                  Contact
                </Link>
              </Button> */}
              {/* <Button
                component="a"
                href="https://forms.gle/5pwrC3iqZqjzfoKu6"
                target="_blank"
                rel="noopener noreferrer"
                variant="text"
                color="inherit"
              
                sx={{
                  color: "#00853e!important",
                  padding: "0 .25rem",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                Contact
              </Button> */}
              {/* <Button
                className={classes.menuButton}
                onClick={() => setEmailOpen(true)}
              >
                <span className={classes.link}>join our team</span>
              </Button> */}

              {/* <Button
                className={classes.menuButton}
          
              >
                <span className={classes.link}>store</span>
              </Button> */}
              <Button
                className={`${classes.link}`}
                sx={{
                  color: "white!important",
                  margin: "0 .25rem!important",
                  padding: "0.25rem .5rem!important",
                  background: "transparent!important",
                  borderRadius: "0!important",
                  textTransform: "uppercase!important",
                  fontSize: "1rem",
                  fontFamily: "'Montserrat'",
                  lineHeight: "1.25",
                  textDecoration: "none",
                }}
              >
                <Link
                  to={{ pathname: "/", hash: "#meet-jeremiah" }}
                  className={`${classes.link}`}
                >
                  MEET JEREMIAH
                </Link>
              </Button>
              <Button className={classes.menuButton}>
                <Link to="/priorities" className={`${classes.link}`}>
                  priorities
                </Link>
              </Button>
              <Button className={classes.menuButton}>
                <Link to="/media" className={`${classes.link}`}>
                  News
                </Link>
              </Button>
              <Button className={classes.menuButton}>
                <Link to="/endorsements" className={`${classes.link}`}>
                  Endorsements
                </Link>
              </Button>
              <Button className={classes.menuButton}>
                <Link
                  to="/students-for-pope/join"
                  className={`${classes.link}`}
                >
                  Students for Pope
                </Link>
              </Button>
              <IconButton
                component="a"
                href="https://instagram.com/popeforcouncil"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <InstagramIcon sx={{ color: "#00853e!important" }} />
              </IconButton>
              <IconButton
                component="a"
                href="https://twitter.com/popeforcouncil"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <TwitterIcon sx={{ color: "#00853e!important" }} />
              </IconButton>
              <IconButton
                component="a"
                href="https://facebook.com/popeforcouncil"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <FacebookIcon sx={{ color: "#00853e!important" }} />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.youtube.com/@JeremiahPopeForCouncil"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <YouTubeIcon sx={{ color: "#00853e!important" }} />
              </IconButton>
              <IconButton
                component="a"
                href="mailto:info@popeforcouncil"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                <EmailIcon sx={{ color: "#00853e!important" }} />
              </IconButton>
              <Button
                className={classes.menuButton}
                sx={{
                  background: "#00853e!important",
                  p: "0.75rem 2rem!important",
                  ml: "1rem!important",
                  color: "white!important",
                  borderRadius: "0!important",
                }}
              >
                <a
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.menuButton}
                >
                  Volunteer
                </a>
              </Button>
              <Button
                className={classes.menuButton}
                sx={{
                  background: "#1d2845!important",
                  p: "0.75rem 2rem",
                  borderRadius: "0 4px 4px 0",
                  color: "white",
                  textTransform: "uppercase",
                  "&:hover": {
                    background: "red!important",
                    color: "white",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                 <Link
                  to="/donate"
                  className={`${classes.link}`}
                >
                  Donate
                </Link>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box display={{ xs: "flex", md: "none", marginTop: "-28px" }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </Toolbar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerList()}
      </Drawer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </AppBar>
  );
};

export default Navbar;
